import styled, { css } from "styled-components";
import { IRibbonStyle } from "./interfaces";;

export const Section = styled.section`
    background-color: ${p => p.theme.c.light};
    overflow: hidden;
    padding-top: 28px;
    margin-top: -1px;
`;

export const Ribbon = styled.div<IRibbonStyle>`
    ${p =>
        p.theme.md.min(css`
            height: 607px;
        `)}

    width: 100%;
    margin-bottom: -243px;
    position: relative;

    ${p =>
        p.theme.xs(css`
            height: 486px;
            margin-bottom: -30px;
        `)}

    ${p =>
        p.theme.md.only(css`
            margin-bottom: -193px;
            height: 500px;
        `)}

    ${p =>
        p.theme.sm.only(css`
            margin-bottom: -193px;
            height: 500px;
        `)}

    .RibbonWrapper {
        height: 100%;
        z-index: 1;
        position: relative;
    }

    .UpperRibbon {
        position: absolute;
        top: -28px;
        height: 28px;
        background-color: ${p => p.theme.c.info};
        width: 100%;
        transform: skewY(5.9deg);
        transform-origin: top left;

        ${p =>
            p.theme.xs(css`
                height: 100px;
                transform: none;
            `)}
    }

    .LowerShadow {
        position: absolute;
        top: 268px;
        height: 5px;
        box-shadow: 0 2px 16px 4px ${p => p.theme.c.blackShadow4};
        width: 100%;
        transform: skewY(15.7deg);
        transform-origin: top left;

        ${p =>
            p.theme.md.only(css`
                top: 219px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                top: 220px;
                transform: skewY(20.05deg);
            `)}

        ${p =>
            p.theme.xs(css`
                bottom: 61px;
                top: auto;
            `)}
    }

    h3, p {
        margin: 0;
    }
    h3 {
        font-size: 28px;
        color: ${p => p.theme.c.info};
        font-weight: 400;
        margin-bottom: 8px;

        ${p =>
            p.theme.md.only(css`
                font-size: 24px;
                margin-bottom: 4px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                font-size: 24px;
                margin-bottom: 4px;
            `)}

        ${p =>
            p.theme.xs(css`
                font-size: 20px;
                margin-bottom: 4px;
            `)}
    }
    p {
        font-size: ${p => p.locale === "el" ? 22 : 24}px;
        line-height: 1.5;
        color: ${p => p.theme.c.snowOnActive};
        font-weight: 300;
        text-align: justify;

        ${p =>
            p.theme.md.only(css`
                font-size: ${p.locale === "el" ? 18 : 20}px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                font-size: ${p.locale === "el" ? 16 : 18}px;
            `)}

        ${p =>
            p.theme.xs(css`
                font-size: 17px;
            `)}
    }


    .Container {
        position: relative;
        width: 412px;
        z-index: 5;
        display: flex;
        flex-direction: column;
        justify-content: center;

        ${p =>
            p.theme.md.only(css`
                width: 350px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                width: 300px;
            `)}

        ${p =>
            p.theme.xs(css`
                padding: 16px;
                padding-top: calc(80% - 10px);
                width: auto !important;
                position: static;
                height: auto !important;
            `)}
    }

    &.Ribbon1 {
        z-index: 3;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
            `)}

        ${p =>
            p.theme.xs(css`
                height: 516px;
                clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
            `)}
        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 0, 0 457px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
                `)}
            background-color: ${p => p.theme.c.boost};
        }
        .Container {
            top: 58px;
            left: 80px;
            width: 432px;
            height: 230px;

            ${p =>
                p.theme.md.only(css`
                    top: 40px;
                    left: 70px;
                    height: 200px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 48px;
                    left: 37px;
                    height: 180px;
                    width: 380px;
                `)}

            ${p =>
                p.theme.xs(css`
                    @media screen and (min-width: 380px) {
                        padding-top: 270px;
                    }
                `)}
        }
        img {
            width: 722px;
            position: absolute;
            right: -30px;
            top: 63px;
            clip-path: polygon(82px -3.7px, 694px 57.7px, 694px 545.2px, 13px 352.6px);
            mask-image: -webkit-gradient(linear, left 70%, right bottom,
                    color-stop(0.1,  transparent),
                    color-stop(0.35,  ${p => p.theme.c.black}),
                    color-stop(1.00,  ${p => p.theme.c.black}));
            &.Firefox {
                mask-image: -webkit-gradient(linear, left bottom, right bottom, color-stop(0.13, transparent), color-stop(0.35, black), color-stop(1, black));
                ${p =>
                    p.theme.xs(css`
                        mask-image: -webkit-gradient(
                            linear,
                            left bottom,
                            left top,
                            color-stop(0.2, transparent),
                            color-stop(0.35, black),
                            color-stop(1, black)
                        );
                    `)}
            }


            ${p =>
                p.theme.md.only(css`
                    width: 570px;
                    right: -22px;
                    top: 58px;
                    clip-path: polygon(82px -5.7px, 694px 57.7px, 694px 545.2px, 13px 352.6px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    width: 585px;
                    right: -22px;
                    top: 33px;
                    clip-path: polygon(82px -8.7px, 694px 54.7px, 694px 545.2px, 13px 352.6px);
                `)}

            ${p =>
                p.theme.xs(css`
                    width: calc(100vw + 30px);
                    max-width: 400px;
                    right: -22px;
                    top: 0;
                    clip-path: none;
                    mask-image: -webkit-gradient(
                        linear,
                        3% 84%,
                        11% top,
                        color-stop(0.1, transparent),
                        color-stop(0.2, black),
                        color-stop(1, black)
                    );

                    @media screen and (min-width: 380px) {
                        right: auto;
                        left: calc((100vw - 400px) / 2);
                        border-right: 9px solid ${p => p.theme.c.info};
                        border-left: 9px solid ${p => p.theme.c.info};
                        box-sizing: border-box;
                    }
                `)}

        }
    }

    &.Ribbon2 {
        z-index: 2;
        clip-path: polygon(0 121px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
            `)}

        ${p =>
            p.theme.xs(css`
                clip-path: polygon(0 3px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -36px);
            `)}

        .RibbonWrapper {
            clip-path: polygon(0 121px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 36px, 0 100%, calc(100% + 1px) calc(100% - 60px), calc(100% + 1px) 0);
                `)}
            background-color: ${p => p.theme.c.pale};
        }
        .UpperRibbon {
            transform: skewY(-5.9deg);
            transform-origin: top right;
            ${p =>
                p.theme.xs(css`
                    height: 100px;
                    transform: none;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    transform: skewY(-7.7deg);
                `)}
        }

        .LowerShadow {
            transform: skewY(-15.75deg);
            transform-origin: top right;
            ${p =>
                p.theme.sm.only(css`
                    top: 220px;
                    transform: skewY(-20.05deg);
                `)}
            ${p =>
                p.theme.xs(css`
                    bottom: 60px;
                    top: auto;
                `)}
        }
        p, h3 {
            color: ${p => p.theme.c.dark};
        }

        .Container {
            top: 138px;
            left: 300px;
            width: 500px;
            height: 260px;

            ${p =>
                p.theme.md.only(css`
                    top: 126px;
                    left: 270px;
                    height: 200px;
                    width: 440px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 140px;
                    left: 220px;
                    height: 160px;
                    width: 420px;
                `)}

            ${p =>
                p.theme.xs(css`
                    padding-top: 44px;
                `)}
        }

        img {
            position: absolute;
            pointer-events: none;
            width: 717px;
            left: -194px;
            top: 139px;
            clip-path: polygon(266px 4.3px, 488px 49.7px, 530px 373.2px, 251px 451.6px);
            ${p =>
                p.theme.md.only(css`
                    width: 593px;
                    left: -163px;
                    top: 111px;
                    clip-path: polygon(226px 4.3px, 488px 49.7px, 530px 373.2px, 201px 451.6px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    width: 593px;
                    left: -163px;
                    top: 111px;
                    clip-path: polygon(226px 4.3px, 488px 49.7px, 530px 373.2px, 201px 451.6px);
                `)}

            ${p =>
                p.theme.xs(css`
                    width: 510px;
                    left: calc((100% - 540px) / 2);
                    top: 182px;
                    clip-path: polygon(165px 44.3px, 357px 29.7px, 340px 363.2px, 161px 371.6px);
                `)}
        }
    }

    &.Ribbon3 {
        z-index: 1;
        pointer-events: none;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
            `)}

        ${p =>
            p.theme.xs(css`
                clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
            `)}

        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 0, 0 427px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
                `)}
            background-color: ${p => p.theme.c.boost};
        }
        .Container {
            top: 131px;
            left: 409px;

            height: 200px;
            display: flex;
            ${p =>
                p.theme.sm.min(css`
                    justify-content: center;
                `)}
            flex-direction: column;

            ${p =>
                p.theme.lg(css`
                    height: 230px;
                    width: 440px;
                `)}

            ${p =>
                p.theme.md.only(css`
                    top: 111px;
                    left: 369px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 110px;
                    left: 236px;
                    height: 190px;
                `)}

            ${p =>
                p.theme.xs(css`
                    padding-top: 50px;

                    h3 {
                        text-align: left;
                    }
                `)}
        }

        h3 {
            text-align: right;
        }
        img {
            position: absolute;
            pointer-events: none;
            transform: rotate(10deg);
            width: 682px;
            right: -56px;
            top: 109px;
            clip-path: polygon(266px 6.3px, 487px 9.7px, 630px 439.2px, 211px 397.6px);
            ${p =>
                p.theme.md.only(css`
                    width: 515px;
                    right: -56px;
                    top: 124px;
                    clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    width: 485px;
                    right: -56px;
                    top: 132px;
                    clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
                `)}

            ${p =>
                p.theme.xs(css`
                    width: 421px;
                    right: calc((100% - 421px) / 2);
                    top: 218px;
                    transform: rotate(4deg);
                    clip-path: none;
                `)}
        }
    }

    &.Ribbon4 {
        z-index: 0;
        background-color: ${p => p.theme.c.pale};


        clip-path: polygon(0 95px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);

        height: 310px;
        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 74px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 74px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -28px);
            `)}
        ${p =>
            p.theme.xs(css`
                clip-path: polygon(0 3px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -36px);
                height: 200px;
            `)}

        .RibbonWrapper {
            background-color: ${p => p.theme.c.pale};
            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 36px, 0 100%, calc(100% + 1px) 100%, calc(100% + 1px) 0);
                `)}
        }
        .UpperRibbon {
            top: -27px;
            transform: skewY(-5.9deg);
            transform-origin: top right;
            z-index: 1;
            ${p =>
                p.theme.sm.only(css`
                    transform: skewY(-7.7deg);
                `)}

            ${p =>
                p.theme.xs(css`
                    top: -28px;
                    transform: none;
                    z-index: 0;
                `)}

        }

        margin-bottom: 0;


        p {
            margin-top: 0;
            padding-top: 167px;
            color: ${p => p.theme.c.dark};
            font-weight: 400;
            font-variant: small-caps;
            margin-bottom: 20px;

            ${p =>
                p.theme.xs(css`
                    padding: 16px;
                    padding-top: 50px;
                    margin-bottom: 0;
                `)}
        }
        p, div {
            text-align: center;

        }
    }
`;
